import { NavLink } from 'react-router';
import React from 'react';

import { ListItem } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { jbColors } from 'theme/jbColors';
import { JBColors } from '@bjb-gcrm/gcrm-frontend-components';

const useStyles = makeStyles(() => ({
  active: {
    color: `${jbColors.core.reflexBlue[100]} !important`,
    backgroundColor: jbColors.app.white,
    fontWeight: 550,
    '@media  (min-width: 1000px)': {
      marginLeft: '25px',
    },
  },
  spaced: {
    display: 'flex !important',
    justifyContent: 'center !important',
    '@media  (min-width: 1000px)': {
      marginLeft: '25px',
    },
    height: '60px',
    marginTop: '-4px',
    fontSize: '14px !important',
  },
}));

/**
 * Navigation button in the top menu bar.
 * @param linkTo The URL that the button points to
 * @param buttonText The Text that the button displays
 * @param onClick The function that is called when the button is clicked
 * @param dataTestId The data-test-id attribute of the button
 */
const NavButton = ({
  linkTo,
  buttonText,
  onClick,
  dataTestId,
}: {
  linkTo: string;
  buttonText: string;
  onClick: any;
  dataTestId?: string | undefined;
}) => {
  const classes = useStyles();

  return (
    <NavLink
      to={linkTo}
      onClick={onClick}
      className={({ isActive }) => `${classes.spaced} ${isActive ? classes.active : ''}`}
      style={{ textDecoration: 'none' }}
    >
      {({ isActive }) => (
        <ListItem data-testid={dataTestId} style={{ color: isActive ? JBColors.core.reflexBlue[100] : '#b1b8da' }}>
          {buttonText}
        </ListItem>
      )}
    </NavLink>
  );
};

export default NavButton;
